import React, { HTMLAttributes } from 'react';
import { classes } from 'typestyle';
import { columnClass } from './index';

export function Column({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={classes(columnClass, className)}
    >
      {children}
    </div>
  );
}
